module.exports = __webpack_public_path__ + "static/media/saone-loire-logo.c7d7650a.png";